export default __webpack_public_path__ + "img/reddit.5adea625efa436d9fc2ebf8701d1e620.svg";